import { useQuery } from '@tanstack/react-query';
import { MdError } from 'react-icons/md';
import { toast } from 'react-toastify';
import ReactIcon from '../components/ReactIcon';
import { DateUtils } from '../helpers/dateUtils';
import { GetItemsShop } from '../services/salesShopItems.service';
import { useShoppingCartStore } from '../store/shoppingCart/shoppingCartStore';

type PropsGetShopItemsPark = {
    Date?: Date;
    ProductId?: number;
    ProductTypeId?: number;
    ProductWaveSide?: 'Left' | 'Right';
};

const currentDate = new Date();

export const useGetShopItemsPark = ({
    Date,
    ProductId,
    ProductWaveSide,
    ProductTypeId,
}: PropsGetShopItemsPark) => {
    const dateFormatted = DateUtils.formatToInitalYear(
        Date || currentDate
    );
    const shoppingCartStore = useShoppingCartStore();
    const { isPending, data } = useQuery({
        queryKey: ['shopPark', dateFormatted, ProductId, ProductWaveSide, ProductTypeId],
        queryFn: async () => {
            const response = await GetItemsShop({
                Date: dateFormatted,
                ProductId,
                ProductTypeCategory: 'Tickets',
                ProductWaveSide,
                ProductTypeId,
            });

            if (
                shoppingCartStore.cartValues &&
                shoppingCartStore.cartValues.length > 0
            ) {
                response.forEach(item => {
                    if (shoppingCartStore.isPaymentLinkCart) return;
                    const target = shoppingCartStore.cartValues!.find(
                        d => d.id === item.id.toString()
                    );
                    if (!target) return;
                    shoppingCartStore.updateItemPrice(item.id.toString(), item.value, dateFormatted);
                });
            }

            return response;
        },
        throwOnError: () => {
            toast.error(
                () => 'Erro ao atualizar os itens do parque disponíveis',
                {
                    toastId: 4,
                    style: {
                        fontSize: '1rem',
                        fontWeight: '400',
                    },
                    position: 'top-right',
                    autoClose: 5000,
                    icon: (
                        <ReactIcon
                            Icon={MdError}
                            size={'1.5rem'}
                            fill="#e40505"
                            color="white"
                        />
                    ),
                }
            );
            return false;
        },
    });

    if(
        dateFormatted.toString() == "2030-01-25" ||
        dateFormatted.toString() == "2030-01-26"
    ) {
        toast.warn("Compras em aberto estão desabilitadas.")
        return {
            isPending: false,
            data: undefined,
        };
    }

    return {
        isPending,
        data,
    };
};
